import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import api from "../../../../../api";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ServiceCard = ({ title, image, description, isActive, onToggle }) => {
  const wordLimit = 10;

  const cleanText = description.replace(/<br>/g, " ");
  const words = cleanText.split(" ");
  const needsTruncation = words.length > wordLimit;

  return (
    <div className={`school-card ${isActive ? "active" : ""}`}>
      <img src={image} className="card-img-top" alt={title} />

      <div className="card-body text-center">
        <strong>{title}</strong>

        <p
          className={`truncate-text-lib ${isActive ? "expanded" : ""}`}
          dangerouslySetInnerHTML={{ __html: description }}
        />

        {needsTruncation && (
          <span
            className="view-more-btn-service"
            onClick={onToggle}
            style={{ cursor: "pointer" }}
          >
            {isActive ? "View Less" : "View More"}
          </span>
        )}
      </div>
    </div>
  );
};

const ServicesSection = () => {
  const [services, setServices] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await api.get("/api/sitepages/about-us/library");

        const cards = res.data.groups?.[4]?.services_section?.cards || [];

        const formatted = cards.map((item) => ({
          title: item.title,
          description: item.description,
          image: item.image_url.startsWith("/storage")
            ? `${process.env.REACT_APP_API_URL}/public${item.image_url}`
            : item.image_url,
        }));

        setServices(formatted);
      } catch (error) {
        console.error("Services API Error:", error);
      }
    };

    fetchServices();
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 3 } },
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 576, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section id="service" className="pb-0 pb-md-5">
      <div className="container">

        <div className="row">
          <div className="sec-title text-center">
            <h2>SERVICES</h2>
          </div>
        </div>

        <div className="services-carousel">
          <Slider {...settings}>
            {services.map((service, index) => (
              <div key={index} className="item px-2">
                <ServiceCard
                  {...service}
                  isActive={activeIndex === index}
                  onToggle={() => handleToggle(index)}
                />
              </div>
            ))}
          </Slider>
        </div>

      </div>
    </section>
  );
};

export default ServicesSection;
